import Fragment from "./fragment";
import FragmentDataType from "../enums/fragment-data-type";
import FragmentSummary from "./fragment-summary";
import { playerReducer } from "../../../storage/reducers";
import { FragmentMessages } from "../../common/fragment-messages";
import FootballState from "../state/football-state";

export default class FumbledSnapRecovered extends Fragment {
    constructor(recoveredBy, recoveredAt) {
        super();
        this.recoveredBy = recoveredBy;
        this.recoveredAt = recoveredAt;

        this.requiredData = [
            {
                name: "recoveredBy",
                type: FragmentDataType.Player,
                appliesToOpponent: () => false,
                displayName: "Recovered By",
                title: (team) => `Recovered By: ${team.teamName}`,
                subtitle: (team) =>
                    `Select a player from ${team.teamName} or enter the roster number`,
                isEditable: true
            },
            {
                name: "recoveredAt",
                type: FragmentDataType.FieldPosition,
                displayName: "Recovered At",
                title: "At",
                subtitle: FragmentMessages.FB_TEAM_FIELD_POSITION,
                showEndZoneYards: (gameConfig) =>
                    gameConfig.general.includeEndZoneYardage
            }
        ];
    }

    updateSummaryContext(summaryContext) {
        summaryContext.eopPrinted = true;
        if (this.recoveredBy) {
            summaryContext.homeTeamHasPossession =
                this.recoveredBy.teamId === summaryContext.homeTeamId;

            if (this.recoveredAt || this.recoveredAt === 0) {
                summaryContext.fieldPosition = this.recoveredAt;
            }

            summaryContext.playerInPossession = this.recoveredBy;
        }
    }

    getPlayers() {
        return [this.recoveredBy];
    }

    getFragmentTeamId() {
        return this.recoveredBy?.teamId;
    }

    getFieldPosition() {
        return this.recoveredAt;
    }

    changesPossession(currentPossessionId) {
        return this.recoveredBy?.teamId != currentPossessionId;
    }

    dirtiesPlaySequence(fragment) {
        return (
            this.recoveredBy &&
            this.recoveredBy.teamId !== fragment.recoveredBy?.teamId
        );
    }

    summarize(summaryContext, stringifier, play) {
        const isContinued =
            play.getNextFragment(this)?.associatedState ===
            FootballState.Continue;

        const recoveryTeam =
            this.recoveredBy?.teamId === summaryContext.homeTeamId
                ? summaryContext.homeTeam
                : summaryContext.awayTeam;

        const messages = [
            `recovered by ${recoveryTeam.teamName} ${stringifier.firstInitial(
                this.recoveredBy
            )}`
        ];

        if (!isContinued) {
            const fieldPosition = stringifier.niceFieldPosition(
                summaryContext.gameConfig.general.fieldLength,
                this.recoveredAt,
                summaryContext.homeTeam?.abbrName,
                summaryContext.awayTeam?.abbrName
            );
            messages.push(` at ${fieldPosition}`);
        }

        return new FragmentSummary(messages.join(" "));
    }

    toJSON() {
        return {
            ...super.toJSON(),
            recoveredBy: playerReducer(this.recoveredBy)
        };
    }
}
